import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
`;
export const Color = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid light-dark(rgba(0, 0, 0, 0.2), rgba(255, 255, 255, 0.2));

  ${({ $size }) => $size === 'extraSmall' &&
    css `
      width: var(--space-400);
      height: var(--space-400);
    `}

  ${({ $size }) => $size === 'small' &&
    css `
      width: var(--space-500);
      height: var(--space-500);
    `}

  ${({ $size }) => $size === 'medium' &&
    css `
      width: var(--space-600);
      height: var(--space-600);
    `}
`;
export const ColorContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${({ $hoverable }) => ($hoverable ? 'pointer' : 'initial')};

  ${({ $appearance, $hoverable, $selected }) => $appearance === 'single-select' &&
    css `
      position: relative;

      &:before {
        position: absolute;

        width: calc(100% + var(--space-150));
        height: calc(100% + var(--space-150));
        content: '';
        display: block;

        border-radius: 50%;
        border: 2px solid transparent;
      }

      ${$hoverable &&
        $selected &&
        css `
        &:before {
          border-color: light-dark(rgb(0, 0, 0), rgb(255, 255, 255));
        }
      `}

      ${$hoverable &&
        !$selected &&
        css `
        &:hover::before {
          border-color: light-dark(rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.4));
        }
      `}
    `}
`;
export const CheckMark = styled.span `
  ${({ $light }) => $light &&
    css `
      color: var(--text-secondary);
    `}

  ${({ $light }) => !$light &&
    css `
      color: var(--text-primary-invert);
    `}
`;
